import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import { State } from 'stores/ReduxStore';

const useSelector: TypedUseSelectorHook<State> = useReduxSelector;

export default useSelector;
